<header class="head">
  <div class="title-row">
    <h2 mat-dialog-title class="ttl">{{ vm?.title ?? 'Fiche de la ligne' }}</h2>
    @if (vm) {
      <span class="pill status" [class]="vm.statusCls">{{ vm.status }}</span>
      @if (vm.interrupted) {
        <span class="pill st-interrupted second">{{ badge }}</span>
      }
      @if (vm.closure) {
        <span class="pill st-closure second" [attr.title]="vm.closure">close</span>
      }
    }
    <span class="grow"></span>
    @if (store.refreshing) {
      <mat-spinner class="spin" diameter="16" aria-label="Mise à jour"></mat-spinner>
    }
    <button mat-icon-button type="button" class="x" (click)="close()" aria-label="Fermer"><mat-icon>close</mat-icon></button>
  </div>
  @if (vm) {
    <div class="sub">
      @for (s of vm.sub; track $index) {
        <span>{{ s }}</span>
      }
    </div>
    <div class="facts">
      @for (p of vm.progress; track $index) {
        <span class="fact prog" [attr.title]="p.title">{{ p.text }}</span>
      }
      @for (f of vm.facts; track f.label) {
        <span class="fact">{{ f.label }} <b>{{ f.day }}</b></span>
      }
    </div>
    @if (vm.siblings.length) {
      <div class="siblings">
        <span class="lbl">Même résident :</span>
        @for (s of vm.siblings; track s.id) {
          <button mat-button type="button" class="sibling" (click)="showLine(s.id)">{{ s.name }}</button>
        }
      </div>
    }
    <div class="actions" [matTooltip]="vm.lock" [matTooltipDisabled]="!vm.lock">
      <button mat-stroked-button type="button" class="a-interruption" [disabled]="!!vm.lock" (click)="openInterruption()">Interruption</button>
      <span class="wrap" [matTooltip]="vm.startLock" [matTooltipDisabled]="!vm.startLock || !!vm.lock">
        <button mat-stroked-button type="button" class="a-start" [disabled]="!!vm.startLock" (click)="openWindow('START')">Début avant le BL</button>
      </span>
      <button mat-stroked-button type="button" class="a-end" [disabled]="!!vm.lock" (click)="openWindow('END')">Fin de facturation</button>
      <button mat-stroked-button type="button" class="a-prescription" [disabled]="!!vm.lock" (click)="openPrescription()">Prescription</button>
    </div>
    <nav class="toc" aria-label="Sections de la fiche">
      @for (s of sections; track s.key) {
        <button type="button" class="toc-item" [class.on]="active === s.key" [attr.data-target]="s.key" (click)="goTo(s.key)">
          {{ s.label }}@if (vm.counts[s.key] !== null) {<span class="n">{{ vm.counts[s.key] }}</span>}
        </button>
      }
    </nav>
  }
</header>

<mat-dialog-content class="content">
  @if (!vm) {
    @if (store.firstLoad || (!store.view && !store.error)) {
      <div class="loading"><mat-spinner diameter="24"></mat-spinner><span>Chargement du dossier…</span></div>
    } @else if (!store.view) {
      <p class="err">{{ store.error }}</p>
      <button mat-stroked-button type="button" class="retry" (click)="retry()">Réessayer</button>
    } @else {
      <p class="err">Ligne {{ lineId }} absente du dossier n° {{ data.orderId }}.</p>
    }
  } @else {
    @if (store.error) {
      <p class="err">Rechargement impossible : {{ store.error }}</p>
    }

    <section data-section="decisions">
      <h3>Décisions</h3>
      <app-rental-line-decisions [line]="vm.line" [store]="store" [readonly]="!!vm.lock" (modify)="onModify($event)" (cancel)="onCancel($event)"></app-rental-line-decisions>
    </section>

    <section data-section="ledger">
      <h3>Facturé</h3>
      <app-rental-line-ledger [line]="vm.line"></app-rental-line-ledger>
    </section>

    <section data-section="due">
      <h3>Au prochain passage</h3>
      @if (!vm.due.length && !vm.credits.length && !vm.incomplete) {
        <p class="empty">Rien à facturer ni à créditer sur cette ligne au prochain passage.</p>
      }
      @if (vm.due.length) {
        <h4>À facturer</h4>
        <table class="tbl due-table">
          <thead>
            <tr>
              <th class="num">Rangs</th>
              <th>Du – au (inclus)</th>
              <th class="num">Qté</th>
              <th class="num">PU HT</th>
              <th class="num">HT</th>
              <th class="num">TTC</th>
              <th>Reports</th>
            </tr>
          </thead>
          <tbody>
            @for (r of vm.due; track $index) {
              <tr>
                <td class="num">{{ r.ranks }}</td>
                <td class="nowrap">{{ r.span }}</td>
                <td class="num">{{ r.qty }}</td>
                <td class="num" [matTooltip]="r.lpp">{{ r.pu }}</td>
                <td class="num">{{ r.ht }}</td>
                <td class="num">{{ r.ttc }}</td>
                <td class="notes">
                  @for (n of r.notes; track $index) {<span>{{ n }}</span>}
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (vm.credits.length) {
        <h4>Avoirs</h4>
        <table class="tbl credit-table">
          <thead>
            <tr>
              <th>Pièce corrigée</th>
              <th class="num">Rangs</th>
              <th>Du – au (inclus)</th>
              <th class="num">Qté</th>
              <th class="num">HT</th>
              <th class="num">TTC</th>
              <th class="fill"></th>
            </tr>
          </thead>
          <tbody>
            @for (c of vm.credits; track $index) {
              <tr class="credit">
                <td>
                  @if (c.link !== null) {
                    <a [routerLink]="['/sales/quotation', c.link]" target="_blank" matTooltip="Ouvrir la pièce corrigée">{{ c.ref }}</a>
                  } @else {
                    <span class="inert">{{ c.ref }}</span>
                  }
                </td>
                <td class="num">{{ c.ranks }}</td>
                <td class="nowrap">{{ c.span }}</td>
                <td class="num">{{ c.qty }}</td>
                @if (c.error) {
                  <td colspan="2" class="err-cell">{{ c.error }}</td>
                } @else {
                  <td class="num">{{ c.ht }}</td>
                  <td class="num">{{ c.ttc }}</td>
                }
                <td class="fill"></td>
              </tr>
            }
          </tbody>
        </table>
      }
      <table class="tbl totals">
        <thead>
          <tr><th></th><th class="num">HT</th><th class="num">TTC</th></tr>
        </thead>
        <tbody>
          @for (t of vm.totals; track t.cls) {
            <tr [class]="t.cls">
              <td>{{ t.label }}</td>
              <td class="num">{{ t.ht }}</td>
              <td class="num">{{ t.ttc }}</td>
            </tr>
          }
        </tbody>
      </table>
      <p class="hint">TTC calculé ligne à ligne, indicatif : le total du dossier fait foi.</p>
      @if (vm.incomplete) {
        <span class="warn">{{ vm.incomplete }}</span>
      }
    </section>

    <section data-section="card">
      <h3>Contrat de location</h3>
      @if (vm.cardMissing) {
        <p class="warn">Contrat de location absent ou illisible : paramètres de facturation inconnus.</p>
      }
      <dl class="card">
        @for (p of vm.card; track p.label) {
          <div class="param" [matTooltip]="p.raw">
            <dt>{{ p.label }}</dt>
            <dd>{{ p.value }}</dd>
          </div>
        }
      </dl>
    </section>

    <section data-section="anomalies">
      <h3>Anomalies @if (vm.blocked) {<span class="pill st-blocked">bloquante</span>}</h3>
      @if (!vm.anomalies.length) {
        <p class="empty">Aucune anomalie.</p>
      } @else {
        <ul class="anomalies" [class.blocked]="vm.blocked">
          @for (a of vm.anomalies; track $index) {
            <li>{{ a }}</li>
          }
        </ul>
      }
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" class="close" (click)="close()">Fermer</button>
</mat-dialog-actions>
